module.exports = __webpack_public_path__ + "img/_DSC7469-mobileVersion.85597588.jpg";